<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card class="md-card-profile" md-alignment="left">

                <div class="md-card-avatar">
                    <img class="img" :src="$auth.user.picture" />
                </div>

                <md-card-content>
                    <h6 class="category text-gray">Your Account</h6>
                    <h4 class="card-title">{{ $auth.user.name }}</h4>


                    <p class="card-description">
                        Email Address
                    </p>
                    <p>{{ $auth.user.email }}</p>

                    <p class="card-description">
                        Email Address Verfied
                    </p>
                    <div>
                        <i v-if="$auth.user.email_verified" class="fa fa-check"></i>
                        <i v-else class="fa fa-times"></i>
                    </div>

                    <p class="card-description">
                        Account Last Updated
                    </p>
                    <p>
                        {{ dateUpdated }}
                    </p>

                    <md-card-actions md-alignment="left">
                        <md-button v-if="!$auth.loading && $auth.isAuthenticated" @click="logout" class="md-primary md-round" title="Log Out of UnitView">Log out</md-button>
                    </md-card-actions>

                </md-card-content>
            </md-card>
        </div>



        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>lock</md-icon>
                    </div>
                    <h4 class="title">
                        GDPR & Data Protection
                    </h4>
                </md-card-header>

                <md-card-content>
                    <h2>General Data Protection Regulation</h2>
                    <p>The EU's <a href="https://gdpr-info.eu/">General Data Protection Regulation</a> covers security and protection of personal data, it requires organisations to safeguard personal data and uphold the privacy rights of individuals.</p>
                    <p>In order to provide you with our service we store and process the personal data you directly provide to UnitView Ltd.</p>
                    <p>Included on this page are the main system functions relating to your personal data, if you would like more information on what data we store, what we do with it and how this effects you please <a href="https://unitview.co.uk/privacy-policy" target="_blank">Read More</a></p>
                    <em>We do not sell your data, use your data for advertising, profile you or your activity nor transmit your data to any third parties for any reason except providing you with our services.</em>
                    <p><b>We are fully GDPR compliant</b></p>
                    <h3 class="margin_top">What does this mean for you?</h3>
                    <p>You have various rights regarding your personal data under GDPR legislation. You can excersie these rights with the options on this page.</p>
                    <p class="margin_bottom">If you make a request, we have one month to respond (although we will endeavour to respond as quickly as possible).</p>


                    <h3 class="margin_top">Questions?</h3>
                    <p>If you have any questions about UnitView Ltd's privacy policy, the data we hold about you, or you would like to exercise one of your data protection rights, please do not hesitate to contact us.</p>
                    <p>Our GDPR Compliance Officer is <b>{{gdprComplianceOfficerName}}</b></p>
                    <div class="md-layout md-alignment-space-between">
                        <div class="md-layout-item md-alignment-top-right md-layout">
                            <md-button v-if="!$auth.loading && $auth.isAuthenticated" :href="gdprComplianceOfficerMailTo" target="_blank" class="md-primary md-round" title="Contact our GDPR Compliance Officer">Contact Us</md-button>
                        </div>
                    </div>


                </md-card-content>

            </md-card>
        </div>




        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>lock</md-icon>
                    </div>
                    <h4 class="title">
                        GDPR Actions
                    </h4>
                </md-card-header>


                <md-card-content>
                     <h2>GDPR Actions</h2>


                    <h3 class="margin_top_extra">Export your data</h3>
                    <h4>Subject Access Request (SAR)</h4>
                    <p>You have the right to request the data we hold relating to you as an individual in a computer readable format so that you can transfer this data to another system, or for any other purpose. We may charge a small fee for this service.</p>
                    <div class="md-layout md-alignment-space-between">
                        <div class="md-layout-item md-alignment-top-right md-layout">
                            <md-button v-if="!$auth.loading && $auth.isAuthenticated" @click="getProfile" class="md-primary md-round" title="Get your Profile">Get Profile</md-button>
                        </div>
                    </div>



                    <h3 class="margin_top">Change your data</h3>
                    <h4>The Right to Rectification</h4>
                    <p>You have the right to request that we correct any information you believe is inaccurate. You also have the right to request Our Company to complete any information you believe is incomplete.</p>
                    <div class="md-layout md-alignment-space-between">
                        <div class="md-layout-item md-alignment-top-right md-layout">
                            <md-button v-if="!$auth.loading && $auth.isAuthenticated" @click="editProfile" :href="gdprChangeUrl" target="_blank" class="md-primary md-round" title="Make Changes to your Information">Edit Profile</md-button>
                        </div>
                    </div>

                    <h3 class="margin_top">Delete your data</h3>
                    <h4>Erasure Request (ER)</h4>
                    <p>You have the right to request that Our Company erase your personal data, under certain conditions.</p>
                    <p>If you would like us to delete all your personal data from our Systems you can request this here. <b>Note that you will be unable to continue to use our services</b> as this involves deleting your user account and removing all personally identifiable information in our Systems</p>
                    <div class="md-layout md-alignment-space-between">
                        <div class="md-layout-item md-alignment-top-right md-layout">
                            <md-button v-if="!$auth.loading && $auth.isAuthenticated" @click="deleteProfile" class="md-primary md-round" title="Delete your User Account">Delete Profile</md-button>
                        </div>
                    </div>



                    

                </md-card-content>

            </md-card>
        </div>


             <div class="md-layout-item md-small-size-100" v-if="showProfile">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>person</md-icon>
                    </div>
                    <h4 class="title">
                        Your Data
                    </h4>
                </md-card-header>


                <md-card-content>
                     <h2>Export your data</h2>

                    <h4>Computer Readable Profile Data</h4>
                    <pre>{{ JSON.stringify($auth.user, null, 2) }}</pre>
                    
                    
                    <md-card-actions md-alignment="left">
                        <md-button v-if="!$auth.loading && $auth.isAuthenticated" @click="downloadProfile" :href="gdprDownloadUrl" class="md-primary md-round" title="Request File">Download</md-button>
                    </md-card-actions>



                </md-card-content>

            </md-card>
        </div>



    </div>
</template>

<script>

    import moment from 'moment';
    import Api from '@/ts/UvApiService';
    import Swal from "sweetalert2";

    export default {
        name: "profile",
        data() {
            return {
                showProfile: false,
                gdprComplianceOfficerName: "Jennifer Myatt",
                gdprComplianceOfficerEmail: "jen@unitview.co.uk",
            }
        },
        computed: {
            dateUpdated() {
                let m = moment(this.$auth.user.updated_at);
                return `${m.format('DD/MM/YYYY')} at ${m.format('HH:mm:ss')}`;
            },
            gdprDownloadUrl() {
                return encodeURI(`mailto:${this.gdprComplianceOfficerEmail}?subject=GDPR | Download Profile`);
            },
            gdprChangeUrl() {
                var url = encodeURI(`mailto:${this.gdprComplianceOfficerEmail}?subject=GDPR | Edit Profile`);
                return url + `&body=${this.editEmailText}`;
            },
            gdprComplianceOfficerMailTo() {
                return encodeURI(`mailto:${this.gdprComplianceOfficerEmail}?subject=GDPR | Data Protection Query`);
            },
            editEmailText() {
                var currentName = this.$auth.user.name;
				var currentEmail = this.$auth.user.email;
				var currentImage = this.$auth.user.picture;
                var txt = `Hi%20UnitView%2C%0A%0AI%20would%20like%20to%20edit%20some%20of%20the%20data%20in%20the%20UnitView%20System%20against%20my%20profile%20%28user%20account%29.%0A%0ACould%20the%20following%20ammendments%20please%20be%20made%20%0A%0AName%20%0ACurrent%20%3A%20${currentName}%0ACorrected%20%3A%20%0A%0A%0AEmail%20%0ACurrent%20%3A%20${currentEmail}%0ACorrected%20%3A%20%0A%0A%0APicture%0ACurrent%20%3A%20${currentImage}%0ACorrected%20%3A%20Please%20paste%20web%20address%20or%20attach%20file%20as%20required%20%0A%0A%0A%0AMany%20thanks%20%0A%0A${currentName}%0A%0A%0A%0A`;
                return txt;
            }
        },
        methods: {
            logout() {
                
                this.$auth.logout({
                    returnTo: window.location.origin
                });
            },
            async getProfile() {
                this.showProfile = true;
                var res = await Api.profile.exportGet(this.$auth.user);
                return res;
            },
            async downloadProfile() {
                 Swal.fire({
                      title: "Download Requested",
                      text: `We will shortly upgrade the system to allow you to download your profile data within the system. In the meantime if you would like to request this immediately please continue with the email`,
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonClass: "md-button md-success btn-fill",
                      cancelButtonClass: "md-button md-danger btn-fill",
                      confirmButtonText: "Yes, Request File",
                      buttonsStyling: false
                  });
            },
              async editProfile() {
                  Swal.fire({
                      title: "System Feature Coming Soon...",
                      text: `We will shortly upgrade the system to allow you to edit your profile in the system. In the meantime if you would like to make changes actioned asap please continue with the email`,
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonClass: "md-button md-success btn-fill",
                      cancelButtonClass: "md-button md-danger btn-fill",
                      confirmButtonText: "Yes, Email",
                      buttonsStyling: false
                  });
            },
            async deleteProfile() {

                var self = this;

                  Swal.fire({
                      title: "Are You Sure?",
                      text: `Deleting your profile will erase all the personal data we hold about you, you will be UNABLE to LOG IN, maintain your client portoflios, buildings or websites. Are you certain you wish to proceed.`,
                      type: "warning",
                      showCancelButton: true,
                      confirmButtonClass: "md-button md-success btn-fill",
                      cancelButtonClass: "md-button md-danger btn-fill",
                      confirmButtonText: "Delete my Data",
                      buttonsStyling: false
                  }).then(result => {
                      if (result.value) {

                          Swal.fire({
                              title: "We're sorry to see you go!",
                              text: `We will action your profile deletion ASAP in accordance with our company policy (and GDPR legislation), you will now be logged out`,
                              type: "warning",
                              showCancelButton: true,
                              confirmButtonClass: "md-button md-success btn-fill",
                              cancelButtonClass: "md-button md-danger btn-fill",
                              confirmButtonText: "Logout",
                              buttonsStyling: false
                          }).then(result => {
                              if (result.value) {
                                  self.logout();
                              }
                          });
                    }
                });
            }
        }
    };
</script>

<style>
    .photo {
        border-radius: 50%;
        width: 100px;
        height: 100px;
        overflow: hidden;
        float: left;
        z-index: 5;
    }
</style>